import { forwardRef, Type } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const componentForwardRef = (component: Type<any>): Type<any> => forwardRef(() => component);
